<ng-container *transloco="let t; read: 'contact'">

  <ng-container *ngIf="contact">
    <h1 class="mbm">
      {{
        contact?.isCompany
          ? contact?.companyName
          : contact.firstName + " " + contact.lastName
      }}
    </h1>
  </ng-container>
  <ng-container *ngIf="!contact">
    <h1 class="mbm">{{ t('newContact') }}</h1>
  </ng-container>

  <kendo-tabstrip>
    <kendo-tabstrip-tab [title]="t('generalInformation')" [selected]="true">
      <ng-template kendoTabContent>
      <form
        [formGroup]="form"
        (submit)="onSubmit()"
        class="flex flexDirRow justSpaceBetween twoCol"
      >
        <kendo-formfield>
          <kendo-label [text]="t('isCompany')"></kendo-label>
          <kendo-switch
            formControlName="isCompany"
            [onLabel]="t('yes')"
            [offLabel]="t('no')"
            ></kendo-switch>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [text]="t('externalNumber')"></kendo-label>
          <kendo-textbox formControlName="externalNumber"></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield *ngIf="form.get('isCompany').value">
          <kendo-label
            [text]="t('companyName')"
          ></kendo-label>
          <kendo-textbox formControlName="companyName"></kendo-textbox>
          <kendo-formerror *ngIf="form.get('companyName').hasError('required')">{{t('isRequiredField')}}</kendo-formerror>
        </kendo-formfield>

        <div *ngIf="form.get('isCompany').value"></div>

        <kendo-formfield *ngIf="!form.get('isCompany').value">
          <kendo-label
            [text]="t('contactTitle')"
          ></kendo-label>
          <kendo-textbox formControlName="title"></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield *ngIf="!form.get('isCompany').value">
          <kendo-label
            [text]="t('salutation')"
          ></kendo-label>
          <kendo-dropdownlist
            [data]="salutations"
            formControlName="salutation"
            valueField="id"
            textField="name"
            [valuePrimitive]="true"
            [defaultItem]="defaultSalutation"
          ></kendo-dropdownlist>
          <kendo-formerror *ngIf="form.get('salutation').hasError('required')">{{t('isRequiredField')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield *ngIf="!form.get('isCompany').value">
          <kendo-label
            [text]="t('firstName')"
          ></kendo-label>
          <kendo-textbox formControlName="firstName"></kendo-textbox>
          <kendo-formerror *ngIf="form.get('firstName').hasError('required')">{{t('isRequiredField')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield *ngIf="!form.get('isCompany').value">
          <kendo-label
            [text]="t('lastName')"
          ></kendo-label>
          <kendo-textbox formControlName="lastName"></kendo-textbox>
          <kendo-formerror *ngIf="form.get('lastName').hasError('required')">{{t('isRequiredField')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [text]="t('street')"></kendo-label>
          <kendo-textbox formControlName="street"></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [text]="t('zip')"></kendo-label>
          <kendo-textbox formControlName="zip"></kendo-textbox>
          <kendo-formerror *ngIf="form.get('zip').hasError('pattern')">{{t('zipWrongFormat')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [text]="t('city')"></kendo-label>
          <kendo-textbox formControlName="city"></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [text]="t('country')"></kendo-label>
          <kendo-textbox formControlName="country"></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield class="phoneFormField">
          <kendo-label [text]="t('phone')"></kendo-label>

          <div class="phone-row">
            <kendo-textbox formControlName="phone" class="phoneTextbox"></kendo-textbox>
            <ng-container *ngIf="form.get('phone')?.value">
              <span (click)="call(form.get('phone')!.value)" class="call-link"><img src="../../../assets/icons/phone-white.svg"></span>
            </ng-container>
          </div>
          <kendo-formerror *ngIf="form.get('phone').hasError('pattern')">{{t('phoneWrongFormat')}}</kendo-formerror>
          <kendo-formhint>{{t('hintPhoneWithoutWhiteSpaces')}}</kendo-formhint>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [text]="t('email')"></kendo-label>
          <kendo-textbox formControlName="email"></kendo-textbox>
          <kendo-formerror *ngIf="form.get('email').hasError('email')">{{t('emailWrongFormat')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [text]="t('website')"></kendo-label>
          <kendo-textbox formControlName="website"></kendo-textbox>
          <kendo-formerror *ngIf="form.get('website').hasError('pattern')">{{t('websiteWrongFormat')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [text]="t('remarks')"></kendo-label>
          <kendo-textbox formControlName="remarks"></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield *ngIf="form.get('isCompany').value">
          <kendo-label
            [text]="t('contactPerson')"
          ></kendo-label>
          <kendo-textbox formControlName="contactPerson"></kendo-textbox>
        </kendo-formfield>

        <div class="footerNav">
          <button
            kendoButton
            (click)="goBack()"
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="info"
            type="button"
            class="mrm mbm"
          >
            {{ t('back') }}
          </button>
          <button
            *ngIf="canEdit"
            kendoButton
            type="submit"
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="success"
            [disabled]="form.pristine || form.invalid"
            class="mrm mbm"
          >
            {{ t('save') }}
          </button>
          <ng-container *ngIf="canEdit">
            <ng-container *permissionIf="'Permissions.Contacts.Delete'">
              <button
                  kendoButton
                  fillMode="solid"
                  size="medium"
                  rounded="medium"
                  themeColor="error"
                  class="mrm mbm"
                  (click)="deletionDialogOpen()"
                  type="button">
                {{ t('delete') }}
              </button>

              <app-delete-confirm-dialog
                  [(opened)]="deletionDialogOpened"
                  [message]="t('deletionMessage')"
                  (confirmed)="delete()"
              ></app-delete-confirm-dialog>
          </ng-container>
          </ng-container>

        </div>
      </form>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab
      *permissionIf="'Permissions.Attachments.Search'"
      [title]="t('attachments')"
    [disabled]="!contact?.id"
    >
      <ng-template kendoTabContent>
        <app-attachments [contactId]="contact.id"></app-attachments>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</ng-container>
